<div class="page-container list-page-container" [testId]="servicenumber + '-' + list + '-page-container'">
  <div class="page-topbar header-section" [class.is-card-mode]="isCardMode" [testId]="servicenumber + '-' + list + '-header-section'">
    <div class="header-main" [testId]="servicenumber + '-' + list + '-header-main'">
      <div class="title-section" [testId]="servicenumber + '-' + list + '-title-section'">
        <h3 [testId]="servicenumber + '-' + list + '-title'">{{ pageTitleKey | i18n }}</h3>
      </div>

      <div class="primary-actions" *ngIf="isCardMode" [testId]="servicenumber + '-' + list + '-primary-actions'">
        <div class="card-add-container">
          <button
            nz-button
            (click)="addServiceNumber()"
            nzType="primary"
            class="add-button"
            [disabled]="!canAddServiceNumber()"
            [nz-tooltip]="tenantType === 'Person' ? ('servicenumber.person-tenant-cannot-add' | i18n) : ''"
            [testId]="'servicenumber-list-add-button'"
          >
            <nz-icon nzType="plus" [testId]="'servicenumber-list-add-icon'" />
            {{ 'servicenumber.add-service-number' | i18n }}
          </button>
        </div>
      </div>
    </div>

    <div class="toolbar-row" *ngIf="!isCardMode" [testId]="servicenumber + '-' + list + '-toolbar-row'">
      <div class="search-container" [testId]="servicenumber + '-' + list + '-search-container'">
        <nz-input-group [nzSuffix]="suffixIconSearch" class="search-input" [testId]="servicenumber + '-' + list + '-search-input-group'">
          <input
            type="text"
            nz-input
            [placeholder]="'servicenumber.search-placeholder' | i18n"
            [(ngModel)]="searchKeywords"
            (keyup.enter)="search()"
            [testId]="servicenumber + '-' + list + '-search-input'"
          />
          <ng-template #suffixIconSearch>
            <i
              nz-icon
              nzType="search"
              (click)="search()"
              class="search-icon"
              nz-tooltip
              [nzTooltipTitle]="'servicenumber.search-tooltip' | i18n"
              [testId]="servicenumber + '-' + list + '-search-icon'"
            ></i>
          </ng-template>
        </nz-input-group>
        <button
          nz-button
          nzType="default"
          (click)="resetSearch()"
          class="reset-button"
          nz-tooltip
          [nzTooltipTitle]="'common.reset' | i18n"
          [testId]="servicenumber + '-' + list + '-reset-button'"
        >
          <i nz-icon nzType="clear" [testId]="servicenumber + '-' + list + '-reset-icon'"></i>
        </button>
      </div>
    </div>

    <ng-container *ngIf="isCardMode">
      <div class="topbar-search card-topbar-search" [testId]="'servicenumber-card-topbar-search'">
        <div class="card-search-row" [testId]="'servicenumber-card-search-row'">
          <nz-input-group [nzPrefix]="prefixSearchIcon" class="card-search-input" [testId]="'servicenumber-card-search-input-group'">
            <input
              type="text"
              nz-input
              [placeholder]="'servicenumber.card.search-placeholder' | i18n"
              [(ngModel)]="searchKeywords"
              (keyup.enter)="search()"
              [testId]="'servicenumber-card-search-input'"
            />
          </nz-input-group>
          <ng-template #prefixSearchIcon>
            <i nz-icon nzType="search" [testId]="'servicenumber-card-search-prefix-icon'"></i>
          </ng-template>

          <div class="card-toolbar-controls" [testId]="'servicenumber-card-toolbar-controls'">
            <nz-select
              nzAllowClear
              [nzPlaceHolder]="'servicenumber.card.all-types' | i18n"
              class="filter-dropdown"
              [(ngModel)]="typeFilter"
              (ngModelChange)="onFilterChange('type', $event)"
              [testId]="'servicenumber-card-type-filter'"
            >
              <nz-option *ngFor="let option of typeOptions" [nzValue]="option.value" [nzLabel]="option.text" />
            </nz-select>

            <nz-select
              nzAllowClear
              [nzPlaceHolder]="'servicenumber.card.robot-status' | i18n"
              class="filter-dropdown"
              [(ngModel)]="robotStatusFilter"
              (ngModelChange)="onCardExtraFilterChange()"
              [testId]="'servicenumber-card-robot-filter'"
            >
              <nz-option *ngFor="let option of robotStatusOptions" [nzValue]="option.value" [nzLabel]="option.text" />
            </nz-select>

            <nz-select
              nzAllowClear
              [nzPlaceHolder]="'servicenumber.card.channel.all' | i18n"
              class="filter-dropdown"
              [(ngModel)]="channelFilter"
              (ngModelChange)="onCardExtraFilterChange()"
              [testId]="'servicenumber-card-channel-filter'"
            >
              <nz-option *ngFor="let option of channelOptions" [nzValue]="option.value" [nzLabel]="option.text" />
            </nz-select>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div
    #pageScroll
    class="page-scroll"
    [class.is-card-mode]="isCardMode"
    (scroll)="isCardMode && onCardScroll($event)"
    [testId]="'servicenumber-list-page-scroll'"
  >
    <ng-container *ngIf="isCardMode; else tableModeTpl">
      <div class="result-meta card-result-meta" [testId]="'servicenumber-card-result-meta'">
        <div class="result-count card-summary" [testId]="'servicenumber-card-summary'">
          {{ 'servicenumber.card.total-found' | i18n: { total: total } }}
        </div>
        <button
          *ngIf="searchKeywords || typeFilter || robotStatusFilter || channelFilter"
          nz-button
          nzType="link"
          type="button"
          class="clear-filters-inline"
          (click)="clearAllFilters()"
          [testId]="'servicenumber-card-clear-filters-btn'"
        >
          {{ 'servicenumber.clear-filter' | i18n }}
        </button>
      </div>

      <div class="content-section card-content-section" [testId]="'servicenumber-card-content-section'">
        <div class="card-scroll-container" [testId]="'servicenumber-card-scroll-container'">
          <nz-spin [nzSpinning]="loading">
            <div class="card-grid" [testId]="'servicenumber-card-grid'">
              <div
                class="service-card"
                *ngFor="let item of visibleServiceNumbers; let i = index"
                [testId]="'servicenumber-card-item-' + i"
                (click)="openServiceNumberDetail(item)"
              >
                <div
                  class="service-status-ribbon-wrap"
                  [ngClass]="{
                    'is-enabled': item.status === 'Enable',
                    'is-disabled': item.status === 'Disable',
                    'is-new': item.status === 'New'
                  }"
                >
                  <span class="service-status-tag service-status-ribbon" [testId]="'servicenumber-card-status-ribbon-' + i">
                    {{ getStatusLabel(item.status) }}
                  </span>
                </div>

                <div class="service-card-menu" (click)="onCardMenuClick($event)">
                  <button
                    nz-button
                    nzType="text"
                    nz-dropdown
                    [nzDropdownMenu]="serviceCardMenu"
                    nzTrigger="click"
                    [testId]="'servicenumber-card-edit-' + i"
                  >
                    <i nz-icon nzType="more"></i>
                  </button>
                  <nz-dropdown-menu #serviceCardMenu="nzDropdownMenu">
                    <ul nz-menu>
                      <li nz-menu-item (click)="editServiceNumber(item)">
                        {{ 'servicenumber.card.menu.edit-settings' | i18n }}
                      </li>
                      <li nz-menu-item *ngIf="canDeleteServiceNumber(item)" (click)="deleteServiceNumber(item, $event)">
                        {{ 'common.delete' | i18n }}
                      </li>
                    </ul>
                  </nz-dropdown-menu>
                </div>

                <div class="service-card-header">
                  <div class="service-card-avatar" [class.has-image]="!!getCardAvatarUrl(item)">
                    <img *ngIf="getCardAvatarUrl(item); else textAvatarTpl" [src]="getCardAvatarUrl(item)" [alt]="item.name || 'avatar'" />
                    <ng-template #textAvatarTpl>{{ getAvatarText(item.name) }}</ng-template>
                  </div>
                  <div class="service-card-main">
                    <div class="service-card-title-row">
                      <h4 [title]="item.name">{{ item.name }}</h4>
                      <span class="type-tag" [ngClass]="getTypeTagClass(item.type)">{{ getServiceNumberTypeLabel(item.type) }}</span>
                    </div>
                    <p
                      #descriptionEl
                      class="service-card-description"
                      [class.is-expanded]="isDescriptionExpanded(item, i)"
                      [attr.data-desc-key]="getDescriptionKey(item, i)"
                      [title]="getCardDescription(item)"
                    >
                      {{ getCardDescription(item) }}
                    </p>
                    <button
                      nz-button
                      nzType="link"
                      class="service-card-description-toggle"
                      *ngIf="shouldShowDescriptionToggle(item, i)"
                      (click)="toggleDescriptionFromEvent($event, item, i)"
                      [testId]="'servicenumber-card-desc-toggle-' + i"
                    >
                      {{
                        isDescriptionExpanded(item, i)
                          ? ('servicenumber.card.description.collapse' | i18n)
                          : ('servicenumber.card.description.expand' | i18n)
                      }}
                    </button>
                  </div>
                </div>

                <div class="service-card-footer">
                  <div class="service-card-channels">
                    <span>{{ 'servicenumber.card.channel' | i18n }}:</span>
                    <ng-container *ngFor="let channelType of getChannelTypes(item)">
                      <img [src]="getChannelIcon(channelType)" [alt]="channelType" />
                    </ng-container>
                  </div>
                  <div class="service-card-statuses">
                    <nz-tag class="robot-status-tag is-enabled" *ngIf="isRobotEnabled(item)">
                      {{ 'servicenumber.card.robot-status.enabled' | i18n }}
                    </nz-tag>
                  </div>
                </div>
              </div>
            </div>

            <div
              *ngIf="isMobileView && hasNextPage"
              #cardLoadMoreAnchor
              class="mobile-load-anchor"
              [testId]="'servicenumber-card-load-anchor'"
              aria-hidden="true"
            ></div>
            <div class="mobile-load-more" *ngIf="isMobileView && loadingMore" [testId]="'servicenumber-mobile-load-more'">
              {{ 'common.loading' | i18n }}
            </div>
          </nz-spin>
        </div>
      </div>

      <div class="pagination-container" *ngIf="total > 0 && isCardMode && !isMobileView" [testId]="'servicenumber-list-pagination-section'">
        <div class="pagination-info" [testId]="'servicenumber-list-pagination-info'">{{
          'common.total-records' | i18n: { total: total }
        }}</div>
        <div class="pagination-controls" [testId]="'servicenumber-list-pagination-controls'">
          <nz-pagination
            nzSize="small"
            [nzShowQuickJumper]="true"
            [nzPageIndex]="pageIndex"
            [nzTotal]="total"
            [nzPageSize]="pageSize"
            [nzShowSizeChanger]="true"
            [nzPageSizeOptions]="[30, 60, 90]"
            (nzPageIndexChange)="nzPageIndexChange($event)"
            (nzPageSizeChange)="nzPageSizeChange($event)"
            [testId]="'servicenumber-list-pagination'"
          />
        </div>
      </div>
    </ng-container>

    <ng-template #tableModeTpl>
      <div class="content-section table-content-section" [testId]="'servicenumber-list-table-section'">
        <div class="table-section">
          <div
            class="filter-strip"
            *ngIf="statusFilter || openTypeFilter || typeFilter || searchKeywords"
            [testId]="'servicenumber-list-filter-section'"
          >
            <div class="filter-tags" [testId]="'servicenumber-list-filter-tags'">
              <nz-tag
                *ngIf="searchKeywords"
                nzMode="closeable"
                [nzColor]="'blue'"
                (nzOnClose)="clearFilter('keywords')"
                [testId]="'servicenumber-list-filter-keywords-tag'"
              >
                {{ 'servicenumber.filter.keywords' | i18n }}: {{ searchKeywords }}
              </nz-tag>
              <nz-tag
                *ngIf="statusFilter"
                nzMode="closeable"
                [nzColor]="'blue'"
                (nzOnClose)="clearFilter('status')"
                [testId]="'servicenumber-list-filter-status-tag'"
              >
                {{ 'common.status' | i18n }}: {{ getStatusLabel(statusFilter) }}
              </nz-tag>
              <nz-tag
                *ngIf="openTypeFilter"
                nzMode="closeable"
                [nzColor]="'blue'"
                (nzOnClose)="clearFilter('openType')"
                [testId]="'servicenumber-list-filter-opentype-tag'"
              >
                {{ 'servicenumber.open-type' | i18n }}: {{ getOpenTypeLabel(openTypeFilter) }}
              </nz-tag>
              <nz-tag
                *ngIf="typeFilter"
                nzMode="closeable"
                [nzColor]="'blue'"
                (nzOnClose)="clearFilter('type')"
                [testId]="'servicenumber-list-filter-type-tag'"
              >
                {{ 'servicenumber.type' | i18n }}: {{ getServiceNumberTypeLabel(typeFilter) }}
              </nz-tag>
            </div>
          </div>

          <nz-table
            #basicTable
            class="table-container fixed-header-table"
            nzSize="middle"
            [nzScroll]="embeddedMode ? { x: '1000px' } : { x: '1000px', y: 'var(--table-scroll-height, calc(100vh - 240px))' }"
            [(nzPageIndex)]="pageIndex"
            [(nzPageSize)]="pageSize"
            [nzData]="listOfData"
            [nzFrontPagination]="false"
            [nzShowPagination]="false"
            [nzLoading]="loading"
            (nzCurrentPageDataChange)="onCurrentPageDataChange($event)"
            [testId]="'servicenumber-list-table'"
          >
            <thead [testId]="'servicenumber-list-table-head'">
              <tr [testId]="'servicenumber-list-table-header-row'">
                <th
                  scope="col"
                  nzWidth="60px"
                  nzLeft
                  class="text-center row-number-column"
                  [testId]="'servicenumber-list-table-header-serial'"
                  >{{ 'common.serial-number' | i18n }}</th
                >
                <th
                  scope="col"
                  *ngIf="isSelector"
                  [nzChecked]="checked"
                  [nzIndeterminate]="indeterminate"
                  (nzCheckedChange)="onAllChecked($event)"
                  [testId]="'servicenumber-list-table-header-checkbox'"
                ></th>
                <th scope="col" *ngFor="let column of columns" [testId]="'servicenumber-list-table-header-' + column.key">
                  {{ column.title }}
                  <ng-container *ngIf="column.filterOptions">
                    <nz-dropdown-menu #menu="nzDropdownMenu" [testId]="'servicenumber-list-filter-dropdown-' + column.key">
                      <ul nz-menu [testId]="'servicenumber-list-filter-menu-' + column.key">
                        <li
                          nz-menu-item
                          *ngFor="let option of column.filterOptions"
                          (click)="onFilterChange(column.key, option.value)"
                          [testId]="'servicenumber-list-filter-option-' + column.key + '-' + option.value"
                        >
                          {{ option.text }}
                        </li>
                        <li nz-menu-divider></li>
                        <li nz-menu-item (click)="clearFilter(column.key)" [testId]="'servicenumber-list-filter-clear-' + column.key">{{
                          'servicenumber.clear-filter' | i18n
                        }}</li>
                      </ul>
                    </nz-dropdown-menu>
                    <a nz-dropdown [nzDropdownMenu]="menu" class="filter-icon" [testId]="'servicenumber-list-filter-icon-{{ column.key }}'">
                      <nz-icon
                        nzType="filter"
                        [nzTheme]="
                          (column.key === 'status' && statusFilter) ||
                          (column.key === 'openType' && openTypeFilter) ||
                          (column.key === 'type' && typeFilter)
                            ? 'fill'
                            : 'outline'
                        "
                        [testId]="'servicenumber-list-filter-icon-' + column.key"
                      />
                    </a>
                  </ng-container>
                </th>
                <th scope="col" nzRight [testId]="'servicenumber-list-table-header-actions'">{{ 'common.actions' | i18n }}</th>
              </tr>
            </thead>
            <tbody [testId]="'servicenumber-list-table-body'">
              <tr
                *ngFor="let data of basicTable.data; let i = index"
                (dblclick)="editServiceNumber(data)"
                [testId]="'servicenumber-list-table-row-' + i"
              >
                <td nzLeft class="text-center row-number-column" [testId]="'servicenumber-list-table-cell-serial-' + i">{{ i + 1 }}</td>
                <td
                  *ngIf="isSelector"
                  [nzChecked]="selectedServiceNumberMap.has(data.id)"
                  (nzCheckedChange)="onItemChecked(data.id, data, $event)"
                  [testId]="'servicenumber-list-table-cell-checkbox-' + i"
                ></td
                ><td *ngFor="let column of columns" [testId]="'servicenumber-list-table-cell-' + column.key + '-' + i">
                  <!-- 服务号类型显示为标签 -->
                  <ng-container *ngIf="column.key === 'type'">
                    <nz-tag [nzColor]="getServiceNumberTypeColor(data[column.key])" [testId]="'servicenumber-list-table-type-tag-' + i">
                      {{ getServiceNumberTypeLabel(data[column.key]) }}
                    </nz-tag>
                  </ng-container>

                  <!-- 服务号公开类型显示为标签 -->
                  <ng-container *ngIf="column.key === 'openType'">
                    <nz-tag [nzColor]="getOpenTypeColor(data[column.key])" [testId]="'servicenumber-list-table-opentype-tag-' + i">
                      {{ getOpenTypeLabel(data[column.key]) }}
                    </nz-tag>
                  </ng-container>

                  <!-- 服务号状态显示为标签 -->
                  <ng-container *ngIf="column.key === 'status'">
                    <nz-tag [nzColor]="getStatusColor(data[column.key])" [testId]="'servicenumber-list-table-status-tag-' + i">
                      {{ getStatusLabel(data[column.key]) }}
                    </nz-tag>
                  </ng-container>

                  <!-- 普通单元格 -->
                  <ng-container *ngIf="column.key !== 'type' && column.key !== 'openType' && column.key !== 'status'">
                    <span
                      class="truncate-text"
                      [title]="data[column.key]"
                      [testId]="'servicenumber-list-table-text-' + column.key + '-' + i"
                      >{{ data[column.key] }}</span
                    >
                  </ng-container>
                </td>
                <td nzRight [testId]="'servicenumber-list-table-cell-actions-' + i">
                  <button
                    nz-button
                    nzType="primary"
                    nzShape="circle"
                    nzSize="small"
                    nz-tooltip
                    [nzTooltipTitle]="'servicenumber.edit-service-number' | i18n"
                    class="action-button edit-button"
                    (click)="editServiceNumber(data)"
                    [testId]="'servicenumber-list-table-edit-button-' + i"
                  >
                    <nz-icon nzType="edit" nzTheme="outline" [testId]="'servicenumber-list-table-edit-icon-' + i" />
                  </button>

                  <!-- 启用按钮（仅当状态非 Enable 时显示） -->
                  <button
                    *ngIf="shouldShowEnableButton(data)"
                    nz-button
                    nzType="primary"
                    nzShape="circle"
                    nzSize="small"
                    nz-tooltip
                    [nzTooltipTitle]="'servicenumber.status.enable' | i18n"
                    class="action-button enable-button"
                    (click)="enableServiceNumber(data)"
                    [disabled]="loading"
                    [testId]="'servicenumber-list-table-enable-button-' + i"
                  >
                    <nz-icon nzType="check-circle" nzTheme="outline" [testId]="'servicenumber-list-table-enable-icon-' + i" />
                  </button>

                  <!-- 禁用按钮（仅当状态为 Enable 时显示） -->
                  <button
                    *ngIf="shouldShowDisableButton(data)"
                    nz-button
                    nzType="default"
                    nzDanger
                    nzShape="circle"
                    nzSize="small"
                    nz-tooltip
                    [nzTooltipTitle]="'servicenumber.status.disable' | i18n"
                    class="action-button disable-button"
                    (click)="disableServiceNumber(data)"
                    [disabled]="loading"
                    [testId]="'servicenumber-list-table-disable-button-' + i"
                  >
                    <nz-icon nzType="close-circle" nzTheme="outline" [testId]="'servicenumber-list-table-disable-icon-' + i" />
                  </button>
                </td>
              </tr>
            </tbody>
          </nz-table>
        </div>
      </div>

      <div class="pagination-container" *ngIf="total > 0 && !isCardMode" [testId]="'servicenumber-list-pagination-section'">
        <div class="pagination-info" [testId]="'servicenumber-list-pagination-info'">{{
          'common.total-records' | i18n: { total: total }
        }}</div>
        <div class="pagination-controls" [testId]="'servicenumber-list-pagination-controls'">
          <nz-pagination
            nzSize="small"
            [nzShowQuickJumper]="true"
            [nzPageIndex]="pageIndex"
            [nzTotal]="total"
            [nzPageSize]="pageSize"
            [nzShowSizeChanger]="true"
            [nzPageSizeOptions]="[30, 60, 90]"
            (nzPageIndexChange)="nzPageIndexChange($event)"
            (nzPageSizeChange)="nzPageSizeChange($event)"
            [testId]="'servicenumber-list-pagination'"
          />
        </div>
      </div>
    </ng-template>
  </div>
</div>
